import { v4 } from 'uuid';

// object for storing reference to our promise-object
const promises = {};

// this function is called by native methods
// @param promiseId - id of the promise stored in global variable promises
export const callJs = (promiseId, data, error) => {
  console.debug('[BRIDGE] callJs ', promiseId, data);
  promises[promiseId].resolve({ data, error });
  // remove reference to stored promise
  delete promises[promiseId];
};

export const callNative = (request, payload) => {
  console.debug('[BRIDGE] callNative', request, payload);
  return new Promise((resolve, reject) => {
    // we generate a unique id to reference the promise later from native function
    const promiseId = v4();
    // save reference to promise in the global variable
    promises[promiseId] = { resolve, reject };

    try {
      window.webkit.messageHandlers.onNativeCalled.postMessage({ promiseId, request, payload });
    } catch (err) {
      console.error(err);
    }
  });
};
